/**
 * Autosuggest Thunks
 *
 * Async thunks for flight location autosuggest operations
 */
import { createAsyncThunk } from '@reduxjs/toolkit';
import type { LocationSuggestion } from '@contracts';
import { fetchFlightAutosuggest } from '../api/autosuggestApi';
import type { RootState, AppDispatch } from '@/store/store';

// ============================================
// Thunks
// ============================================

/**
 * Fetch location autosuggest results
 *
 * @param query - Search query (city name, airport code, etc.)
 * @returns Array of location suggestions
 */
export const fetchAutosuggestThunk = createAsyncThunk<
  LocationSuggestion[],
  string,
  { state: RootState; dispatch: AppDispatch; rejectValue: string }
>('flights/fetchAutosuggest', async (query, { rejectWithValue }) => {
  try {
    const suggestions = await fetchFlightAutosuggest(query);
    return suggestions;
  } catch (error) {
    if (error instanceof Error) {
      return rejectWithValue(error.message);
    }
    return rejectWithValue('Failed to fetch autosuggest results');
  }
});
